import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedCreateAccount = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 72 72" width={width} height={height}>
            <g>
                <path
                    className={styles.cls1}
                    d="M35.46,71.42c-19.48,0-35.33-15.85-35.33-35.33c0-19.48,15.85-35.33,35.33-35.33s35.33,15.85,35.33,35.33
		C70.79,55.57,54.94,71.42,35.46,71.42z M35.46,4.36c-17.5,0-31.73,14.23-31.73,31.73c0,17.5,14.23,31.73,31.73,31.73
		s31.73-14.23,31.73-31.73C67.19,18.6,52.96,4.36,35.46,4.36z"
                />
                <g>
                    <g>
                        <path
                            className={styles.cls1}
                            d="M47.44,20.52H23.64c-3.85,0-6.99,3.13-6.99,6.99v14.43c0,3.85,3.13,6.99,6.99,6.99h23.81
				c3.85,0,6.99-3.13,6.99-6.99V27.5C54.43,23.65,51.3,20.52,47.44,20.52z M53.18,41.94c0,3.16-2.57,5.73-5.73,5.73H23.64
				c-3.16,0-5.73-2.57-5.73-5.73V27.5c0-3.16,2.57-5.73,5.73-5.73h23.81c3.16,0,5.73,2.57,5.73,5.73V41.94z"
                        />
                        <path
                            className={styles.cls1}
                            d="M47.44,49.67H23.64c-4.27,0-7.74-3.47-7.74-7.74V27.5c0-4.27,3.47-7.74,7.74-7.74h23.81
				c4.27,0,7.74,3.47,7.74,7.74v14.43C55.18,46.2,51.71,49.67,47.44,49.67z M23.64,22.52c-2.75,0-4.98,2.23-4.98,4.98v14.43
				c0,2.75,2.23,4.98,4.98,4.98h23.81c2.75,0,4.98-2.23,4.98-4.98V27.5c0-2.75-2.24-4.98-4.98-4.98H23.64z"
                        />
                    </g>
                    <g>
                        <path
                            className={styles.cls1}
                            d="M30.13,35.24c0.87-0.86,1.38-2.03,1.38-3.28c0-2.54-2.07-4.6-4.6-4.6s-4.6,2.06-4.6,4.6
				c0,1.25,0.5,2.42,1.38,3.28c-1.72,1.34-2.78,3.68-2.78,6.22c0,0.35,0.28,0.63,0.63,0.63h10.77c0.35,0,0.63-0.28,0.63-0.63
				C32.92,38.92,31.85,36.58,30.13,35.24z M22.17,40.83c0.18-2.19,1.26-4.11,2.87-4.99c0.19-0.11,0.32-0.31,0.32-0.53
				c0.01-0.22-0.1-0.43-0.28-0.55c-0.95-0.62-1.52-1.67-1.52-2.8c0-1.85,1.5-3.35,3.35-3.35s3.35,1.5,3.35,3.35
				c0,1.13-0.57,2.18-1.52,2.8c-0.18,0.12-0.29,0.33-0.28,0.55c0.01,0.22,0.13,0.42,0.32,0.53c1.61,0.88,2.69,2.8,2.87,4.99H22.17z"
                        />
                        <path
                            className={styles.cls1}
                            d="M32.29,42.83H21.52c-0.76,0-1.38-0.62-1.38-1.38c0-2.46,0.91-4.76,2.48-6.29c-0.69-0.92-1.07-2.03-1.07-3.21
				c0-2.95,2.4-5.35,5.35-5.35s5.35,2.4,5.35,5.35c0,1.18-0.37,2.29-1.07,3.21c1.56,1.53,2.48,3.82,2.48,6.29
				C33.67,42.22,33.05,42.83,32.29,42.83z M23.04,40.08h7.74c-0.32-1.6-1.19-2.93-2.37-3.58c-0.42-0.23-0.69-0.67-0.71-1.15
				c-0.02-0.49,0.22-0.95,0.62-1.21c0.74-0.48,1.18-1.3,1.18-2.18c0-1.43-1.16-2.6-2.6-2.6c-1.43,0-2.6,1.16-2.6,2.6
				c0,0.88,0.44,1.69,1.18,2.17c0.4,0.26,0.64,0.72,0.63,1.2c-0.02,0.49-0.3,0.93-0.71,1.16C24.22,37.15,23.36,38.48,23.04,40.08z"
                        />
                    </g>
                    <g>
                        <path
                            className={styles.cls1}
                            d="M49.56,28.38H36c-0.35,0-0.63,0.28-0.63,0.63s0.28,0.63,0.63,0.63h13.55c0.35,0,0.63-0.28,0.63-0.63
				S49.9,28.38,49.56,28.38z"
                        />
                        <path
                            className={styles.cls1}
                            d="M49.56,30.39H36c-0.76,0-1.38-0.62-1.38-1.38c0-0.76,0.62-1.38,1.38-1.38h13.55c0.76,0,1.38,0.62,1.38,1.38
				C50.94,29.77,50.32,30.39,49.56,30.39z"
                        />
                    </g>
                    <g>
                        <path
                            className={styles.cls1}
                            d="M49.56,34.09H36c-0.35,0-0.63,0.28-0.63,0.63c0,0.35,0.28,0.63,0.63,0.63h13.55c0.35,0,0.63-0.28,0.63-0.63
				C50.19,34.37,49.9,34.09,49.56,34.09z"
                        />
                        <path
                            className={styles.cls1}
                            d="M49.56,36.1H36c-0.76,0-1.38-0.62-1.38-1.38s0.62-1.38,1.38-1.38h13.55c0.76,0,1.38,0.62,1.38,1.38
				S50.32,36.1,49.56,36.1z"
                        />
                    </g>
                    <g>
                        <path
                            className={styles.cls1}
                            d="M49.56,39.8H36c-0.35,0-0.63,0.28-0.63,0.63c0,0.35,0.28,0.63,0.63,0.63h13.55c0.35,0,0.63-0.28,0.63-0.63
				C50.19,40.09,49.9,39.8,49.56,39.8z"
                        />
                        <path
                            className={styles.cls1}
                            d="M49.56,41.81H36c-0.76,0-1.38-0.62-1.38-1.38c0-0.76,0.62-1.38,1.38-1.38h13.55c0.76,0,1.38,0.62,1.38,1.38
				C50.94,41.19,50.32,41.81,49.56,41.81z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default GetStartedCreateAccount;
